/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const CardInstitutional = (props) => {
  const {
    inverse,
    icon,
    children,
    imgSrc = '',
    image,
    imgAlt,
    video,
    videoSrc,
    videoAlt,
    config,
    getCardIcon
  } = props
  // const { getCardIcon } = useCard()

  return (
    <div className={resolveProps(props, config, 'CardInstitutional')}>
      {!!imgSrc && imgSrc ? (
        <div className="mdn-CardInstitutional--imageThumb">
          <img src={imgSrc} alt={imgAlt} />
        </div>
      ) : (
        ''
      )}
      {videoSrc ? (
        <div className="mdn-CardInstitutional--videoThumb">
          <img src={videoSrc} alt={videoAlt} />
        </div>
      ) : (
        ''
      )}
      {getCardIcon(icon)}
      <div className="mdn-CardInstitutional-content">{children}</div>
    </div>
  )
}

export default CardInstitutional

CardInstitutional.propTypes = {
  inverse: PropTypes.bool,
  image: PropTypes.bool,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  video: PropTypes.bool,
  videoSrc: PropTypes.string,
  videoAlt: PropTypes.string
}
